import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/RISIconPalette.css';
import '../../../styles/railSeoSprite.css';

const RISPalette = (props) => {
  const risOptionsDisplay = (
    <div className={`risPalette`}>
      <div style={{ width: '49%' }}>
        {props.risIconPaletteOptions.slice(1, 5)?.map((item, idx) => (
          <a key={item.key} href={item.url}>
            <span className={`${item.iconName} sprite`}></span>
            {item.text}
          </a>
        ))}
      </div>
      <div style={{ width: '51%' }}>
        {props.risIconPaletteOptions.slice(5)?.map((item, idx) => (
          <a key={item.key} href={item.url} style={{ width: '94%' }}>
            <span className={`${item.iconName} sprite`}></span>
            {item.text}
          </a>
        ))}
      </div>
    </div>
  );
  return (
    <div className="railInformationServices">
      <div className="risHeader">{props?.trainInfoServiceText}</div>
      {risOptionsDisplay}
    </div>
  );
};

RISPalette.propTypes = {
  risIconPaletteOptions: PropTypes.array.isRequired,
  trainInfoServiceText: PropTypes.string.isRequired
};

export default RISPalette;
